<template>
  <div>
        <!-- Form tambah/edit rekening, tersembunyi secara default -->
    <div
      class="account-form-container"
      v-show="showForm"
      style="margin-bottom: 2rem;"
    >
      <div class="form-card">
        <h2 class="form-title">Informasi Rekening Bank</h2>
        <form @submit.prevent="submitForm" class="account-form">
          <div class="form-group">
            <label class="form-label">Nama Rekening</label>
            <input
              v-model="form.account_name"
              type="text"
              required
              class="form-input"
              placeholder="Enter account holder name"
            >
          </div>
          <div class="form-group">
            <label class="form-label">Nomor Rekening</label>
            <input
              v-model="form.account_number"
              type="text"
              required
              class="form-input"
              placeholder="Enter account number"
            >
          </div>
          <div class="form-group">
            <label class="form-label">Nama Bank</label>
            <select
              v-model="form.bank_name"
              required
              class="form-select"
            >
              <option value="" disabled selected>Pilih Bank Kamu</option>
              <option value="bca">BCA</option>
              <option value="bni">BNI</option>
              <option value="mandiri">Mandiri</option>
              <option value="permata">Permata</option>
            </select>
          </div>
          <div class="checkbox-group">
            <input
              v-model="form.is_primary"
              type="checkbox"
              id="primary-account"
              class="checkbox-input"
            >
            <label for="primary-account" class="checkbox-label">
              Set as primary account
            </label>
          </div>
          <button
            type="submit"
            class="submit-button"
            :disabled="loading"
            :class="{ 'button-loading': loading }"
          >
            <span v-if="!loading">Save Account</span>
            <span v-else class="loading-spinner"></span>
          </button>
        </form>
      </div>
    </div>
    <!-- Tabel rekening -->
    <div class="accounts-table-container" v-if="!showForm">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">
        <button
          class="submit-button"
          style="width: auto; padding: 0.5rem 1.25rem; font-size: 1rem;"
          @click="showForm = !showForm"
          v-if="!showForm"
        >
          + Tambah Rekening Baru
        </button>
      </div>
      <h2 class="form-title">Rekening Bank Kamu</h2>
      <table class="accounts-table">
        <thead>
          <tr>
            <th>Nama Rekening</th>
            <th>Nomor Rekening</th>
            <th>Bank</th>
            <th>Rekening Utama</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="account in accounts" :key="account.id">
            <td>{{ account.account_name }}</td>
            <td>{{ account.account_number }}</td>
            <td>{{ getBankName(account.bank_name) }}</td>
            <td>
              <font-awesome-icon
                v-if="account.is_primary"
                :icon="['fas', 'check-circle']"
                class="primary-icon"
              />
            </td>
            <td>
              <button class="action-button edit-button" title="Edit" @click="handleEdit(account)">
                <font-awesome-icon :icon="['fas', 'edit']" />
              </button>
              <button class="action-button delete-button" title="Delete" @click="handleDelete(account)">
                <font-awesome-icon :icon="['fas', 'trash']" />
              </button>
            </td>
          </tr>
          <tr v-if="accounts.length === 0">
            <td colspan="5" class="no-accounts">Belum ada rekening bank tersimpan</td>
          </tr>
        </tbody>
      </table>
    </div>



  </div>
</template>

<style scoped>
.account-form-container {
  display: flex;
  justify-content: center;
  padding: 2rem;
}

.form-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 2rem;
  width: 100%;
  max-width: 500px;
}

.accounts-table-container {
  margin: 2.5rem auto 0 auto;
  width: 100%;
  max-width: 1100px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  padding: 2rem 2.5rem;
}

.accounts-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  margin-top: 1.5rem;
  font-size: 1rem;
}

.accounts-table thead th {
  background: #f7fafc;
  color: #2d3748;
  font-weight: 600;
  padding: 1rem 0.75rem;
  border-bottom: 2px solid #e2e8f0;
  text-align: left;
}

.accounts-table tbody td {
  padding: 0.9rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
  vertical-align: middle;
}

.accounts-table tbody tr:last-child td {
  border-bottom: none;
}

.accounts-table tbody tr:hover {
  background: #f1f5f9;
  transition: background 0.2s;
}

.accounts-table .primary-icon {
  color: #38a169;
  font-size: 1.2em;
}

.action-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.35rem 0.5rem;
  border-radius: 6px;
  transition: background 0.15s;
  font-size: 1.1em;
}

.edit-button:hover {
  background: #e6f7ff;
  color: #3182ce;
}

.delete-button:hover {
  background: #fff5f5;
  color: #e53e3e;
}

.no-accounts {
  text-align: center;
  color: #a0aec0;
  font-style: italic;
  padding: 1.5rem 0;
}

.form-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 1.5rem;
  text-align: center;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

.form-input, .form-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.9375rem;
  transition: all 0.2s;
  background-color: #f8fafc;
}

.form-input:focus, .form-select:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
}

.form-select {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 1em;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
}

.checkbox-input {
  width: 1.25rem;
  height: 1.25rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  margin-right: 0.75rem;
  cursor: pointer;
}

.checkbox-label {
  font-size: 0.875rem;
  color: #4a5568;
  cursor: pointer;
}

.submit-button {
  width: 100%;
  padding: 0.875rem;
  background-color: #4299e1;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  font-size: 0.9375rem;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
}

.submit-button:hover {
  background-color: #3182ce;
}

.submit-button:disabled {
  background-color: #a0aec0;
  cursor: not-allowed;
}

.button-loading {
  color: transparent;
}

.loading-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: translate(-50%, -50%) rotate(360deg); }
}

.error-message, .success-message {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
}

.error-message {
  background-color: #fff5f5;
  color: #e53e3e;
  border: 1px solid #fed7d7;
}

.success-message {
  background-color: #f0fff4;
  color: #38a169;
  border: 1px solid #c6f6d5;
}

.error-message i, .success-message i {
  margin-right: 0.5rem;
}
</style>

<script>
import { ref } from 'vue'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'

export default {
  name: 'MyAccount',
  components: {
    FontAwesomeIcon
  },
  setup() {
    const form = ref({
      account_name: '',
      account_number: '',
      bank_name: 'bca',
      is_primary: false
    })
    const loading = ref(false)
    const error = ref('')
    const success = ref(false)
    const showForm = ref(false)
    const editingAccountId = ref(null)

    const accounts = ref([])

    const fetchAccounts = async () => {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/bank-accounts/`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        })
        accounts.value = response.data
      } catch (err) {
        console.error('Failed to fetch accounts:', err)
      }
    }

    const getBankName = (bankCode) => {
      const banks = {
        bca: 'BCA',
        bni: 'BNI',
        mandiri: 'Mandiri',
        permata: 'Permata'
      }
      return banks[bankCode] || bankCode
    }

    const handleEdit = (account) => {
      form.value = {
        account_name: account.account_name,
        account_number: account.account_number,
        bank_name: account.bank_name,
        is_primary: account.is_primary
      }
      editingAccountId.value = account.id
      showForm.value = true
      error.value = ''
      success.value = false
    }

    const handleDelete = async (account) => {
      const result = await Swal.fire({
        title: 'Hapus rekening ini?',
        text: 'Aksi ini tidak dapat dibatalkan.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Batal',
        width: 350,
        heightAuto: false,
        customClass: {
          popup: 'swal2-popup swal2-small'
        }
      })
      if (result.isConfirmed) {
        loading.value = true
        try {
          await axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/bank-accounts/${account.id}/`, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          })
          await fetchAccounts()
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: '<span style="font-size:0.85em">Rekening berhasil dihapus!</span>',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            width: 350,
            customClass: {
              popup: 'swal2-popup swal2-small',
              title: 'swal2-title-small'
            }
          })
        } catch (err) {
          Swal.fire({
            toast: true,
            position: 'center',
            icon: 'error',
            title: 'Gagal menghapus rekening',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            width: 350
          })
        } finally {
          loading.value = false
        }
      }
    }

    const submitForm = async () => {
      loading.value = true
      error.value = ''
      success.value = false

      try {
        let response
        if (editingAccountId.value) {
          // Edit mode: PATCH request
          response = await axios.patch(
            `${process.env.VUE_APP_API_BASE_URL}/api/bank-accounts/${editingAccountId.value}/`,
            {
              account_name: form.value.account_name,
              account_number: form.value.account_number,
              bank_name: form.value.bank_name,
              is_primary: form.value.is_primary
            },
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json'
              }
            }
          )
        } else {
          // Add mode: POST request
          response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/bank-accounts/`, {
            account_name: form.value.account_name,
            account_number: form.value.account_number,
            bank_name: form.value.bank_name,
            is_primary: form.value.is_primary
          }, {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              'Content-Type': 'application/json'
            }
          })
        }

        if (response.status === 200 || response.status === 201) {
          success.value = true
          form.value = {
            account_name: '',
            account_number: '',
            bank_name: 'bca',
            is_primary: false
          }
          editingAccountId.value = null
          fetchAccounts()
          showForm.value = false
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'success',
            title: '<span style="font-size:0.85em">Rekening berhasil tersimpan!</span>',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              popup: 'swal2-popup swal2-small',
              title: 'swal2-title-small'
            }
          })
        }
      } catch (err) {
        let message = ''
        if (err.response) {
          if (err.response.status === 400) {
            message = err.response.data?.error || 'Invalid data provided'
            error.value = message
          } else if (err.response.status === 401) {
            message = 'Please login again'
            error.value = message
          } else {
            message = 'Failed to save account. Please try again later.'
            error.value = message
          }
        } else {
          message = 'Network error. Please check your connection.'
          error.value = message
        }
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'error',
          title: message,
          showConfirmButton: false,
          timer: 2500,
          timerProgressBar: true
        })
      } finally {
        loading.value = false
      }
    }

    // Fetch accounts when component mounts
    fetchAccounts()

    return {
      form,
      loading,
      error,
      success,
      accounts,
      submitForm,
      getBankName,
      showForm,
      handleEdit,
      handleDelete
    }
  }
}
</script>
